//
//
//
//
//
//
//
//
//

import { VueShowdown } from 'vue-showdown';
export default {
  name: 'AppNotices',
  inject: ['cmsBaseUrl', 'httpClient'],
  props: {
    code: {
      type: String,
      default: '',
    },
  },
  components: {
    VueShowdown,
  },
  computed: {
    displayingNotifications() {
      return this.notifications.filter(item => !(this.storedNotifications && this.storedNotifications[`notification_${item.id}`] && this.storedNotifications[`notification_${item.id}`].showed)
          && item.settings.some(setting => setting.section === 'all' || setting.section === this.code || (setting.section === '/' && location.pathname === '/')));
    },
    currentCabinetOnOpen() {
      return this.notifications.filter(item => item.frequently === 'alltime' && item.settings.some(setting => setting.section === this.code || (setting.section === '/' && location.pathname === '/')));
    },
    currentCabinetOnceADay() {
      return this.notifications.filter(item => item.frequently === 'onceaday' && item.settings.some(setting => setting.section === this.code || (setting.section === '/' && location.pathname === '/')));
    },
  },
  data: () => ({
    notifications: [],
    storedNotifications: {}
  }),
  async created() {
    await this.getNotifications()
    this.resetNotifications()
  },
  watch: {
    '$i18n.locale'() {
      this.getNotifications()
      this.resetNotifications()
    },
    code() {
      this.resetNotifications()
    }
  },
  methods: {
    async getNotifications() {
      const { data } = await this.httpClient.get(`${this.cmsBaseUrl}/notices`, {
        params: {
          locale: this.$i18n.locale
        }
      })
      if (data.data) {
        this.notifications = data.data
      }
    },
    updateNotifications() {
      try {
        this.storedNotifications = JSON.parse(localStorage.getItem('notifications')) || {}
      } catch (e) {
        this.storedNotifications = {}
      }
    },
    resetNotifications() {
      let result = localStorage.getItem('notifications')
      try {
        result = JSON.parse(result) || {}
      } catch (e) {
        result = {}
      }
      this.currentCabinetOnOpen.forEach(({ id }) => {
        if (result[`notification_${id}`]) {
          result[`notification_${id}`].showed = false;
        }
      });
      this.currentCabinetOnceADay.forEach(({ id }) => {
        if (result[`notification_${id}`] && result[`notification_${id}`].showed) {
          const date1 = new Date();
          const date2 = new Date(result[`notification_${id}`].showDate);
          const diffDays = Math.ceil(Math.abs(date2 - date1) / (1000 * 60 * 60 * 24));
          if (diffDays > 1) {
            result[`notification_${id}`].showed = false;
          }
        }
      });
      localStorage.setItem('notifications', JSON.stringify(result))
      this.updateNotifications()
    },
    hide(id) {
      let result = localStorage.getItem('notifications')
      try {
        result = JSON.parse(result) || {}
      } catch (e) {
        result = {}
      }
      result[`notification_${id}`] = {
        showed: true,
        showDate: new Date(),
      }
      localStorage.setItem('notifications', JSON.stringify(result))
      this.updateNotifications()
    },
  }
}
